import { Component, Inject, OnInit } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { MatDialogRef, MAT_DIALOG_DATA } from "@angular/material/dialog";
import { MatSnackBar } from "@angular/material/snack-bar";
import { NgxUiLoaderService } from "ngx-ui-loader";
import { validationmethod } from "src/app/shared/models/validationmethod";
import { CommonService } from "src/app/shared/services/common.service";
import { JsignalService } from "src/app/shared/services/jsignal.service";
import { LocalStorageSettingsService } from "src/app/shared/services/local-storage-settings.service";
import {
  ReviewActivityPopupConfigComponent,
  EditData,
} from "src/app/user/review-activity-config/review-activity-popup-config/review-activity-popup-config.component";

@Component({
    selector: "app-create-signal-sources-pop-up",
    templateUrl: "./create-signal-sources-pop-up.component.html",
    styleUrls: ["./create-signal-sources-pop-up.component.scss"],
    standalone: false
})
export class CreateSignalSourcesPopUpComponent implements OnInit {
  SignalSourcesForm!: FormGroup;
  isEditMode: boolean = false;
  titleText: string = "Create Signal Source";     

  constructor(
    private fb: FormBuilder,
    public dialogref: MatDialogRef<ReviewActivityPopupConfigComponent>,
    private commonService: CommonService,
    private snackBar: MatSnackBar,
    private spinner: NgxUiLoaderService,
    private jsignalsService: JsignalService,
    private validation: validationmethod,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private localStorage: LocalStorageSettingsService,
    private validate: validationmethod,
  ) {}

  ngOnInit(): void {
    this.buildSignalSourcesForm();

    if (this.data?.mode === "edit") {
      console.log("Edit Mode Data:", this.data.rowData);
      this.isEditMode = true;
      this.titleText = "Update Signal Source";
      this.patchForm();
    }
  }

  patchForm() {
    if (!this.data?.rowData) return;

    this.SignalSourcesForm.patchValue({
      sourceType: this.data.rowData.value,
      sourceName: this.data.rowData.name,
    });
  }

  buildSignalSourcesForm() {
    this.SignalSourcesForm = this.fb.group({
      sourceType: ["", Validators.required],
      sourceName: ["", [Validators.required,this.validate.restrictAllSpecialCharactersExceptHyphenAndUnderscore]],
    });
  }

  onCreate() {
    if (this.SignalSourcesForm.invalid) {
      this.SignalSourcesForm.markAllAsTouched();
      return;
    }
    const DnsName = this.localStorage.getSettings("dnsName");
    const Workspaceid = this.localStorage.getSettings("WorkspaceId"); 

    const formValue = this.SignalSourcesForm.value;

    console.log(formValue);

  const payload = [{
    configType: "SIGNAL_SOURCE",
    name: formValue.sourceName,
    value:  formValue.sourceType,
    dnsId: DnsName,        
    workspaceId: Workspaceid
  }];
  console.log(payload);

  this.spinner.start();
    this.jsignalsService.createSignalSourceConfiguration(payload).subscribe({
      next: (response) => {

        if(response.error === true){
          this.snackBar.open(response.statusMessage , "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.snackBar.open(response.statusMessage , "Close", {
          duration: 3000,
        });
        this.spinner.stop();
         this.dialogref.close(true);
      },
      error: (error) => {
        console.error("Error ", error);
        this.snackBar.open(error.error.statusMessage, "Close", {
          duration: 3000,
        });
        this.spinner.stop();
        //  this.dialogref.close(true);
      },
    });

  }

  onUpdate() {
    if (this.SignalSourcesForm.invalid) {
      this.SignalSourcesForm.markAllAsTouched();
      return;
    }
  const formValue = this.SignalSourcesForm.value;
  const DnsName = this.localStorage.getSettings("dnsName");
  const Workspaceid = this.localStorage.getSettings("WorkspaceId"); 

  const payload = {
    configType: "SIGNAL_SOURCE",
    name: formValue.sourceName,
    value:  formValue.sourceType,
    dnsId: DnsName,        
    workspaceId: Workspaceid
  };
  console.log(payload);
  console.log("Row ID:", this.data.rowData.id);

  this.spinner.start();
    this.jsignalsService.updateSignalConfigurationbasedOnType(this.data.rowData.id, payload).subscribe({
      next: (response) => {

        if(response.error === true){
          this.snackBar.open(response.statusMessage , "Close", {
            duration: 3000,
          });
          this.spinner.stop();
          return;
        }
        this.snackBar.open(response.statusMessage , "Close", {
          duration: 3000,
        });
        this.spinner.stop();
        this.dialogref.close(true);
      },
      error: (error) => {
        console.error("Error ", error);
        this.snackBar.open(error.error.statusMessage, "Close", {
          duration: 3000,
        });
        this.spinner.stop();
        // this.dialogref.close(true);
      },
    });

    
  }

  onCancel() {
    this.dialogref.close(true);
  }
}
